import * as Sentry from '@sentry/react'
import React from 'react'
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom'

import { isProduction } from '@/config/api'

if (isProduction) {
  Sentry.init({
    dsn: 'https://e365c319a8e84b7c9ccc5759ec9ce978@o4506308949508096.ingest.us.sentry.io/4506308953112576',
    integrations: [
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect: React.useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
      Sentry.replayIntegration({
        maskAllText: false,
        maskAllInputs: false,
      }),
      Sentry.breadcrumbsIntegration({
        console: true,
        dom: true,
        fetch: true,
        history: true,
        xhr: true,
      }),
    ],
    beforeBreadcrumb(breadcrumb) {
      return breadcrumb.category === 'ui.click' ||
        breadcrumb.category === 'ui.input'
        ? null
        : breadcrumb
    },
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    tracesSampleRate: 1.0,
    // Set `tracePropagationTargets` to all subdomains of b2breservas.com.br
    tracePropagationTargets: ['https://agency.b2breservas.com.br/'],
    // Capture Replay for 10% of all sessions,
    // plus for 100% of sessions with an error
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  })
}
